/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeHeading3, BaSeShapeButton } from '@base/react';
import React from 'react';
import { useDisplay } from '../../hook/useDisplay';
import Depoiment from './depoiment';
import {
  Container,
  ContainerDots,
  ContainerText,
  Content,
  ContentDepoiments,
} from './style';

function Depoiments() {
  const depoimentsData = [
    {
      id: 1,
      desc: 'Dedico uma parte de minha vida a este mero depoimento. O Empretec é um seminário extraordinário, que mudou minha vida por completo, desde o meu modo de pensar e agir até como me dedico a tudo que faço. Aprendi no Empretec que tudo na vida é ter um certo comportamento e foco em nossos objetivos. Somos todos capazes de inovar e empreender a nossa própria vida. Recomendei a todos que conheço e que desejam evoluir. Sou grato por essa ótima experiência de ter vivenciado e aprendido muito com o Empretec.',
      name: 'Vinícius Luiz da Silva',
      city: 'Florianópolis, SC',
    },
    {
      id: 2,
      desc: 'A experiência de fazer o Empretec foi transformadora! Durante uma semana de intensa imersão, somos provocados a refletir de maneira crítica sobre nossos comportamentos como empreendedores e como pessoas. Essas reflexões emergem a partir de exercícios, dinâmicas superinteressantes e instrutores capacitados, que nos mobilizam a fazer uma verdadeira revolução interna! No mínimo, saímos estimulados a lapidar nossas fortalezas e ressignificar nossas fraquezas com vistas a alçarmos voos mais altos com outro olhar e percepção sobre o mundo à nossa volta. Recomendo a todos!',
      name: 'Carol Azevedo',
      city: 'Salvador, BA',
    },
  ];

  const { isLargeDisplay } = useDisplay();

  const [currentIndex, setCurrentIndex] = React.useState(0);

  const showNextDepoiment = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % depoimentsData.length);
  };

  const showPreviousDepoiment = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? depoimentsData.length - 1 : prevIndex - 1,
    );
  };

  return (
    <Container id="6">
      <Content>
        <ContainerText>
          <BaSeHeading3>
            Quem fez <strong>recomenda</strong>
          </BaSeHeading3>
        </ContainerText>
        <ContentDepoiments>
          {isLargeDisplay() ? (
            currentIndex > 0 ? (
              <BaSeShapeButton
                buttonType="button"
                color="#FF9797"
                nameIcon="system/arrow-left-s-line"
                onClick={showPreviousDepoiment}
                shape="circle"
                size="medium"
                sizeIcon="medium"
                type="primary"
              />
            ) : (
              <div style={{ width: 40 }}>‎ </div>
            )
          ) : (
            <></>
          )}

          <Depoiment
            city={depoimentsData[currentIndex].city}
            id={depoimentsData[currentIndex].id}
            lengthList={depoimentsData.length}
            desc={depoimentsData[currentIndex].desc}
            name={depoimentsData[currentIndex].name}
          />

          {isLargeDisplay() ? (
            currentIndex === depoimentsData.length - 1 ? (
              <div style={{ width: 40 }}>‎ </div>
            ) : (
              <BaSeShapeButton
                buttonType="button"
                color="#FF9797"
                nameIcon="system/arrow-right-s-line"
                onClick={showNextDepoiment}
                shape="circle"
                size="medium"
                sizeIcon="medium"
                type="primary"
              />
            )
          ) : (
            <></>
          )}
        </ContentDepoiments>
      </Content>
      {!isLargeDisplay() && (
        <ContainerDots>
          {depoimentsData.map((_, index) => (
            <div
              onClick={() => setCurrentIndex(index)}
              style={{
                width: index === currentIndex ? 50 : 25,
                height: 7,
                borderRadius: 10,
                backgroundColor: index === currentIndex ? 'black' : '#8B99A7',
              }}
            >
              ‎{' '}
            </div>
          ))}
        </ContainerDots>
      )}
    </Container>
  );
}

export default Depoiments;
